import { IconName } from "@fortawesome/fontawesome-svg-core";
import { ICardCommonData } from "../card-common-data/card-common-data";

export interface IAchievement extends ICardCommonData {
    iconString: string;
}
export class Achievement implements IAchievement {
    constructor(
        public readonly title: string,
        public readonly content: string,
        public readonly iconString: IconName,
    ) { }
}
